module.exports = __webpack_public_path__ + "media/images/flags/64/France-937c8df0e601d8e5d90a6b0f1527aa2e.png";